import {Segment} from 'semantic-ui-react';

function ComplaintsRegistration() {
  return (
    <Segment>
      <h1>ثبت شکایات</h1>
      <div>
        <p>
          در صورت بروز هر گونه مشکل در فرایند ثبت نام با
          &nbsp;
          <a href='https://t.me/medmoshaver_admin'>ادمین گروه مشاوره در تلگرام</a>
          &nbsp;
          در ارتباط باشید.
        </p>
        <p className='text-center'>
          <a href='https://t.me/medmoshaver_admin'>ادمین گروه مشاوره در تلگرام</a>
        </p>
      </div>
    </Segment>
  );
}

export default ComplaintsRegistration;
